import React from 'react';
import { Skill } from '../types';
// eslint-disable-next-line
import GithubLogo from '../../../images/github.png';
// eslint-disable-next-line
import VelogLogo  from '../../../images/velog.png';
import styled from 'styled-components';

const skillsData: Skill[] = [
  { category: 'Web Framework', items: [
    {'React': "/images/skills-icons/react-icon.png"}, 
    {'Flask': "/images/skills-icons/flask-icon.png"}, 
    {'Node': "/images/skills-icons/nodejs-icon.png"}] },
  { category: 'Game Utility', items: [
    {'Unity': "/images/skills-icons/unity-icon.png"}, 
    {'Unreal': "/images/skills-icons/unreal-icon.png"},] },
  { category: 'Language', items: [
    {'C': "/images/skills-icons/c-icon.png"}, 
    {'C++': "/images/skills-icons/cpp-icon.png"}, 
    {'C#': "/images/skills-icons/cs-icon.png"},
    {'Python': "/images/skills-icons/python-icon.png"}, 
    {'Javascript': "/images/skills-icons/javascript-icon.png"}, 
    {'Typescript': "/images/skills-icons/typescript-icon.png"}] }
];

// eslint-disable-next-line
const PersonalLink = styled.a`
  & + & {
    margin-left: 8px;
  }
`;

const About: React.FC = () => {

  return (
    <section id="about" className="about">
      <div className="about-container">
        <h2>About Me</h2>
        <p>Hello! I'm a passionate developer. I build web applications and enjoy creating interactive user experiences.</p>
        <div className="my-link">
          {/* eslint-disable-next-line */}
          {/* <PersonalLink href="#"><img src={GithubLogo} alt="Github Logo" width="32" height="32" /></PersonalLink> */}
          {/* eslint-disable-next-line */}
          {/* <PersonalLink href="#"><img src={VelogLogo} alt="Velog Logo" width="32" height="32" /></PersonalLink> */}
        </div>
        <div className="about-details">
          <span className="line"></span>
          {skillsData.map((skill, index) => (
            <div key={index} className="skills-box">
              <label>{skill.category}</label>
              <ul className="skills">
                {skill.items.map((item: any, idx: number) => (
                  <li key={idx}>
                    <img 
                      src={`${process.env.PUBLIC_URL}${item[Object.keys(item)[0]]}`} 
                      alt={`${Object.keys(item)[0]}-icon`} 
                      width='auto' 
                      height='24px' />
                    <span>{Object.keys(item)[0]}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      <div className="about-decoration"></div>
    </section>
  );
};

export default About;